export default __webpack_public_path__ + "static/media/banner-text.7b1cb30a.png";